import WidgetEventListResourceModel from '../../generated/types/model/resource/WidgetEventListResourceModel';

export default class WidgetEventListResourceViewModel extends WidgetEventListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
